import type { ChangeEvent, ComponentProps, FC } from "react";
import { useState } from "react";
import { TextField } from "@kivra/react-components";

interface OwnProps {
  isInvalid: boolean;
  hintText: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const TextFieldWithOnBlurValidation: FC<
  ComponentProps<typeof TextField> & OwnProps
> = ({ isInvalid, hintText, value, onChange, ...props }) => {
  const [shouldValidate, setShouldValidate] = useState(false);
  const handleBlur = () => {
    if (value) {
      setShouldValidate(true);
    }
  };
  return (
    <TextField
      {...props}
      value={value}
      onBlur={handleBlur}
      onChange={onChange}
      errorMessage={shouldValidate && isInvalid ? hintText : ""}
    />
  );
};
